import { Button } from '@/components/ui/button'
import { Car } from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

interface FooterProps {
  onOpenDemo: () => void
}

export function Footer({ onOpenDemo }: FooterProps) {
  const { t } = useI18n()

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container mx-auto px-4 text-center space-y-8">
        <div className="max-w-2xl mx-auto space-y-6">
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tighter leading-tight">
            {t('footer.title')}
          </h2>
          <p className="text-lg text-muted/80 leading-relaxed font-medium">
            {t('footer.subtitle')}
          </p>
          <Button
            onClick={onOpenDemo}
            size="lg"
            variant="secondary"
            className="h-14 px-8 text-lg font-bold tracking-tight w-full sm:w-auto"
          >
            {t('footer.demo')}
          </Button>
        </div>

        <div className="pt-16 border-t border-muted/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 opacity-80">
            <Car className="h-6 w-6" />
            <span className="font-extrabold text-xl tracking-tighter">
              Parkko
            </span>
          </div>
          <p className="text-sm opacity-60 font-medium">
            © {new Date().getFullYear()} Parkko Sistemas. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  )
}
